/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import {
  Layout,
  Typography,
  Image,
  Row,
  Col,
  Tabs,
  Menu,
  Dropdown,
  Spin,
  Space,
  Popover,
  Empty,
  Tag,
  Modal,
  Button,
} from 'antd';
import './styles/detail-incidents.scss';
import ListIncidentDetail from './components/detail-incidents/ListDetail';
import FormIncidentDetail from './components/detail-incidents/FormDetail';
import Notes, { EStatus } from './components/detail-incidents/Notes';
import ShareIncidentDetail from './components/detail-incidents/ShareIncident';
import {
  EExportTypeIncident,
  EFilterResponseStatusIncidents,
  IPayloadActionUpdateDetailIncident,
  IPayLoadDeactiveUser,
  IPayloadGetActivityLog,
  IPayloadGetDetail,
  IResponseIncidentDetail,
  IPayloadLoadingChatIncidents,
} from './interfaces';
import { useDispatch } from 'react-redux';
import {
  loadingIncidentsDetailAction,
  updateDetailIncidentAction,
  postDeactiveUserAction,
  loadingActivityLogIncidentAction,
  loadingChatIncidentsAction,
} from 'actions/incidents';
import moment from 'moment';
import { useParams } from 'react-router';
import { FlagFilled, FlagOutlined, RetweetOutlined, CopyOutlined } from '@ant-design/icons';
import {
  INCIDENT_ATTR_TYPES,
  IPayloadGetCreateTestIncident,
  IPayloadGetListIncidentAttrByOrg,
  IPayloadGetSettingServey,
} from 'pages/setting/interfaces';
import { apiGetListIncidentAttrByOrg } from 'api/incident-attr';
import {
  getLlmRiskJudge,
  getLlmRiskJudgeLatest,
  getLlmChatResponsePredict,
  getLlmChatResponsePredictLatest,
} from 'api/incidents';
import { showError, showSuccess } from 'components/standby-notice';
import Chat from './components/detail-incidents/Chat';
import { ModalConfirm } from 'components/modal-confirm';
import { useAppSelector } from 'app/hooks';
import ActivityLog from './components/detail-incidents/Log';
import { removeUrlParameter, storage } from 'utils';
import { API_URL } from 'config';
import { useLocation, useHistory } from 'react-router-dom';
import { get, has } from 'lodash';
import { translate } from 'libs';
import { useTranslation } from 'react-i18next';
import { loadingCountNotificationsAction, SET_TOTAL_NOTIFICATION } from 'actions/notifications';
import { IPayloadLoadingCountNotifications } from 'pages/notifications/interfaces';
import { getCreateTestIncidentAction, getSettingServeyAction } from 'actions/organization';

const { Header, Content } = Layout;
// const initialBoundsChat: IBoundsChat = {
//   left: 0,
//   top: 0,
//   bottom: 0,
//   right: 0,
// };

interface IModal {
  typeModal: string;
  contentText: string;
  textConfirm: string;
  titleModal: string;
  isDeleted: boolean;
}

let refFormDetail: any = () => null;

const { TabPane } = Tabs;

const DetailIncidentsContent = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { id }: any = useParams();
  const { state }: any = useLocation();
  const { i18n } = useTranslation();
  const ref: any = useRef(null);

  const checkOpenModalChat = () => {
    const url = new URLSearchParams(history.location.search);
    return url.has('open_chat') && url.get('open_chat') === '1';
  };

  const defaultVisibleChat: boolean = !!state?.defaultVisibleChat || checkOpenModalChat();
  const indexMessageChat: number = state?.indexMessageChat;

  const currentLanguageCode: string = i18n.language;

  const [loading, setLoading] = useState<boolean>(false);
  const [infoModal, setInfoModal] = useState<IModal>();
  const [idChangeStatus, setIdChangeStatus] = useState<string>('');
  const [codeStatusChange, setCodeStatusChange] = useState<number>(0);
  const [isDisable, setIsDisable] = useState<boolean>(false);
  const [data, setData] = useState<IResponseIncidentDetail | null>(null);

  const [isVisibleShare, setIsVisibleShare] = useState(false);
  const [isVisiableConfirm, setIsVisiableConfirm] = useState<boolean>(false);
  const [optionsPriority, setOptionsPriority] = useState<any[]>();
  const [activeKeyTab, setActiveKeyTab] = useState<string>('1');
  const [listActiviLog, setListActiviLog] = useState<any[]>([]);
  const [surveyStatus, setSurveyStatus] = React.useState<boolean>(false);
  const [standByAI, setStandByAI] = React.useState<string>('');
  const [localGovId, setLocalGovId] = React.useState<number>(0);
  const [createTestIncident, setCreateTestIncident] = React.useState<{ [key: string]: any }>();
  // /const [isAllowServey, setIsAllowServey] = useState<boolean>(false);
  const [loadingRiskJudge, setLoadingRiskJudge] = useState<boolean>(false);
  const [riskJudgeSuccess, setRiskJudgeSuccess] = useState<boolean>(false);
  const chatsCountAtRiskJudge = useRef<number | null>(null);
  const [loadingChatResponse, setLoadingChatResponse] = useState<boolean>(false);
  const [isVisibleChatResponseModal, setIsVisibleChatResponseModal] = useState<boolean>(false);
  const [chatResponseResult, setChatResponseResult] = useState<{
    answer: string;
    reason: string;
    summary: string[];
  } | null>(null);
  const chatResponsePredictCacheRef = useRef<{
    result: { answer: string; reason: string; summary: string[] };
    message_count: number;
  } | null>(null);
  const [isVisibleRiskJudgeModal, setIsVisibleRiskJudgeModal] = useState<boolean>(false);
  const [isVisibleAISummaryModal, setIsVisibleAISummaryModal] = useState<boolean>(false);
  const [riskJudgeResult, setRiskJudgeResult] = useState<{
    summary: string;
    chief_complaint: string[];
    classification: string;
    level: string;
    reason: string;
    sub_level?: string[];
  } | null>(null);
  const [chatCount, setChatCount] = useState<{
    total: number;
    user: number;
    admin: number;
  } | null>(null);

  /**
   * State for Chat
   */
  const isLoading: boolean = useAppSelector((state) => state.incidents.isLoading);
  const statusChats: string = useAppSelector((state) => state.incidents.statusChats);
  const chats: any[] = useAppSelector((state) => state.incidents.chats);
  const isVisibleNoticeDetail: boolean = useAppSelector(
    (state) => state.notifications.isVisibleNoticeDetail
  );
  const isVisibleSystemAlert: boolean = useAppSelector(
    (state) => state.notifications.isVisibleSystemAlert
  );

  const [isVisibleChat, setIsVisibleChat] = useState<boolean>(defaultVisibleChat);
  // const [isDiabledMoveChat, setIsDiabledMoveChat] = useState<boolean>(true);
  // const [boundsChat, setBoundsChat] = useState<IBoundsChat>(initialBoundsChat);
  const [currentRole, setCurrentRole] = React.useState('');
  const roles: any[] = useAppSelector((state) => state.auth.roles);
  const profile: any = useAppSelector((state) => state.auth.profile);

  const isAIVisible = React.useMemo(() => {
    if (!standByAI || standByAI === 'DISABLED') return false;
    if (standByAI === 'ALL_ADMIN') return true;
    if (standByAI === 'STANDBY_ADMIN_ONLY') {
      const email: string = profile?.email || '';
      return email.endsWith('@stopit.co.jp') || email.endsWith('@standby-corp.jp');
    }
    return false;
  }, [standByAI, profile?.email]);

  // const draggleChatRef: any = React.createRef();

  React.useEffect(() => {
    if (isVisibleNoticeDetail || isVisibleSystemAlert) {
      /**
       * cancel chat when modal notice show
       */
      handleCancelChat();
    }
  }, [isVisibleNoticeDetail, isVisibleSystemAlert]);

  React.useEffect(() => {
    if (defaultVisibleChat && indexMessageChat && !data?.admin_id) {
      handleVisibleChat();
    }
  }, [defaultVisibleChat, indexMessageChat, id]);

  React.useEffect(() => {
    let currentIncidentRole = '';
    for (const role of roles) {
      if (
        get(data, 'org_id._id') === role.org_id ||
        get(data, 'org_id.path', '').includes(role.org_id)
      ) {
        currentIncidentRole = role.role_name;
        break;
      }
    }
    setCurrentRole(currentIncidentRole);
  }, [data?._id, roles]);

  const listShare: any[] = [
    {
      type: EExportTypeIncident.PDF_INCIDENT,
      title: translate('incidents.detail.header.menuDownload.incidentPDF'),
    },
    {
      type: EExportTypeIncident.EXCEL_INCIDENT,
      title: translate('incidents.detail.header.menuDownload.incidentExcel'),
    },
    {
      type: EExportTypeIncident.PDF_ACTIVITY_LOG,
      title: translate('incidents.detail.header.menuDownload.activityLogPDF'),
    },
    {
      type: EExportTypeIncident.EXCEL_ACTIVITY_LOG,
      title: translate('incidents.detail.header.menuDownload.activityLogExcel'),
    },
  ];

  const menuShare = (
    <Menu className="menu_list">
      {listShare.map((item: any, index: number) => {
        return (
          <Menu.Item className="menu_item" key={index} onClick={() => handelExportFile(item.type)}>
            {item.title}
          </Menu.Item>
        );
      })}
    </Menu>
  );
  const defaultItem = {
    code: null,
    color: '',
    name: translate('incidents.detail.header.menuFlag.None'),
    _id: null,
  };

  const menuFlag = (
    <Menu className="menu_list flag">
      {optionsPriority && optionsPriority.length > 0 ? (
        [defaultItem].concat(optionsPriority).map((item, index) => {
          return (
            <Menu.Item className="menu_item" key={index} onClick={() => prorityChange(item)}>
              <Space size={12}>
                {item?.color ? <FlagFilled style={{ color: item?.color }} /> : <FlagOutlined />}
                {item?.name}
              </Space>
            </Menu.Item>
          );
        })
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={translate('list.empty.flag')} />
      )}
    </Menu>
  );

  const handelExportFile = (type: EExportTypeIncident) => {
    switch (type) {
      case EExportTypeIncident.PDF_INCIDENT:
        getExportFilePDFIncidentDetail();
        break;
      case EExportTypeIncident.EXCEL_INCIDENT:
        getExportFileExcelIncidentDetail();
        break;
      case EExportTypeIncident.PDF_ACTIVITY_LOG:
        getExportFilePDFActivityLog();
        break;
      case EExportTypeIncident.EXCEL_ACTIVITY_LOG:
        getExportFileExcelActivityLog();
        break;
      default:
        break;
    }
  };

  const getExportFilePDFIncidentDetail = () => {
    const data = {
      incident_id: id,
      lang: currentLanguageCode,
      standby_token: storage.getToken(),
    };
    const query: string = new URLSearchParams(data).toString();
    const urlDownload: string = `${API_URL}/incident-export/pdf?${query}`;
    window.open(urlDownload);
  };

  const getExportFileExcelIncidentDetail = () => {
    const data = {
      incident_id: id,
      lang: currentLanguageCode,
      standby_token: storage.getToken(),
    };
    const query: string = new URLSearchParams(data).toString();
    const urlDownload: string = `${API_URL}/incident-export/excel?${query}`;
    window.open(urlDownload);
  };

  const getExportFilePDFActivityLog = () => {
    const data = {
      incident_id: id,
      lang: currentLanguageCode,
      standby_token: storage.getToken(),
    };
    const query: string = new URLSearchParams(data).toString();
    const urlDownload: string = `${API_URL}/incident-export/activity-log/pdf?${query}`;
    window.open(urlDownload);
  };

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    showSuccess(translate('common.copy_success') || 'コピーしました');
  };

  const handleChatResponsePredict = async () => {
    setChatResponseResult(null);
    setIsVisibleChatResponseModal(true);

    const cached = chatResponsePredictCacheRef.current;
    if (cached && cached.message_count === chats.length) {
      setChatResponseResult(cached.result);
      return;
    }

    setLoadingChatResponse(true);
    try {
      const response = await getLlmChatResponsePredict(id, localGovId);
      const raw = response?.data;
      setChatResponseResult(raw?.result ?? null);
      if (raw?.result) {
        chatResponsePredictCacheRef.current = {
          result: raw.result,
          message_count: chats.length,
        };
      }
    } catch (error) {
      setIsVisibleChatResponseModal(false);
      showError(translate('common.error'));
    } finally {
      setLoadingChatResponse(false);
    }
  };

  const applyRiskJudgeData = (responseData: any) => {
    setChatCount(responseData?.chat_count ?? null);
    const result = responseData?.result ?? null;
    if (result) {
      const levelTableMatch = result.reason?.match(/レベル表の(.+?)[。.]/);
      if (levelTableMatch) {
        const matches = [...levelTableMatch[1].matchAll(/「([^」]+)」/g)];
        result.sub_level = matches.length > 0 ? matches.map((m: any) => m[1]) : undefined;
      }
    }
    setRiskJudgeResult(result);
  };

  const handleRiskJudge = async () => {
    chatsCountAtRiskJudge.current = chats.length;
    setLoadingRiskJudge(true);
    try {
      const response = await getLlmRiskJudge(id, localGovId);
      applyRiskJudgeData(response?.data);
      setRiskJudgeSuccess(true);
      showSuccess(translate('common.success'));
    } catch (error) {
      showError(translate('common.error'));
    } finally {
      setLoadingRiskJudge(false);
    }
  };

  const runRiskJudgeSilently = async () => {
    chatsCountAtRiskJudge.current = chats.length;
    setLoadingRiskJudge(true);
    try {
      const response = await getLlmRiskJudge(id, localGovId);
      applyRiskJudgeData(response?.data);
      setRiskJudgeSuccess(true);
    } catch (error) {
      // silent: auto-triggered on page load
    } finally {
      setLoadingRiskJudge(false);
    }
  };

  const checkLatestRiskJudge = async () => {
    try {
      const response = await getLlmRiskJudgeLatest(id);
      const responseData = response?.data;
      if (responseData?.result) {
        const lastRunCount = responseData?.message_count;
        const currentCount = responseData?.current_message_count;
        const hasNewMessageSinceLastRun =
          typeof lastRunCount === 'number' &&
          typeof currentCount === 'number' &&
          lastRunCount !== currentCount;
        if (hasNewMessageSinceLastRun) {
          runRiskJudgeSilently();
        } else {
          applyRiskJudgeData(responseData);
          chatsCountAtRiskJudge.current = chats.length;
          setRiskJudgeSuccess(true);
        }
      } else {
        runRiskJudgeSilently();
      }
    } catch (error) {
      runRiskJudgeSilently();
    }
  };

  const checkLatestChatResponsePredict = async () => {
    try {
      const response = await getLlmChatResponsePredictLatest(id);
      const responseData = response?.data;
      if (responseData?.result && responseData?.message_count !== undefined) {
        chatResponsePredictCacheRef.current = {
          result: responseData.result,
          message_count: responseData.message_count,
        };
      } else {
        chatResponsePredictCacheRef.current = null;
      }
    } catch (error) {
      chatResponsePredictCacheRef.current = null;
    }
  };

  const getExportFileExcelActivityLog = () => {
    const data = {
      incident_id: id,
      lang: currentLanguageCode,
      standby_token: storage.getToken(),
    };
    const query: string = new URLSearchParams(data).toString();
    const urlDownload: string = `${API_URL}/incident-export/activity-log/excel?${query}`;
    window.open(urlDownload);
  };

  const getActivityLog = () => {
    const payload: IPayloadGetActivityLog = {
      query: {
        incident_id: id,
      },
      onSuccess: (data) => {
        if (Array.isArray(data)) {
          setListActiviLog(data);
        }
      },
      onError: () => {},
    };

    return dispatch(loadingActivityLogIncidentAction(payload));
  };

  const loadingCountNotice = React.useCallback(() => {
    const payload: IPayloadLoadingCountNotifications = {
      onSuccess: (data: any) => {
        dispatch({
          type: SET_TOTAL_NOTIFICATION,
          payload: {
            total: data?.total_badge,
          },
        });
      },
      onError: (errorCode: string) => {
        console.log('🚀 ~ errorCode', errorCode);
      },
    };

    return dispatch(loadingCountNotificationsAction(payload));
  }, []);

  const getIncidentDetail = () => {
    setLoading(true);
    const payload: IPayloadGetDetail = {
      query: {
        incident_id: id,
      },
      onSuccess: (data) => {
        setLoading(false);
        setData(data);
        loadingCountNotice();
      },
      onError: () => {
        setLoading(false);
      },
    };

    return dispatch(loadingIncidentsDetailAction(payload));
  };

  React.useEffect(() => {
    if (!data?.org_id?._id) return;
    loadingPriorityByOrg(data?.org_id?._id);
  }, [data?._id]);

  const loadingPriorityByOrg = React.useCallback(async (id) => {
    const query: IPayloadGetListIncidentAttrByOrg['query'] = {
      organization_id: id,
      type: INCIDENT_ATTR_TYPES.PRIORITY,
    };

    const getListType = await apiGetListIncidentAttrByOrg(query);

    setOptionsPriority(getListType?.data?.values || []);
  }, []);

  const [chatsInitiallyLoaded, setChatsInitiallyLoaded] = useState<boolean>(false);
  const latestCheckedIdRef = useRef<string | null>(null);

  const loadingChats = (id) => {
    const payload: IPayloadLoadingChatIncidents = {
      incident_id: id,
      onSuccess: () => {
        setChatsInitiallyLoaded(true);
      },
    };

    return dispatch(loadingChatIncidentsAction(payload));
  };

  useEffect(() => {
    // setData(null);
    setChatsInitiallyLoaded(false);
    latestCheckedIdRef.current = null;
    chatResponsePredictCacheRef.current = null;
    getSettingServey();
    getCreateTestIncident();
    getIncidentDetail();
    loadingChats(id);
  }, [id]);

  useEffect(() => {
    if (chatsCountAtRiskJudge.current !== null && chats.length !== chatsCountAtRiskJudge.current) {
      setRiskJudgeSuccess(false);
      setRiskJudgeResult(null);
      setChatCount(null);
    }
  }, [chats.length]);

  useEffect(() => {
    if (!id || !chatsInitiallyLoaded || !isAIVisible || !localGovId) return;
    if (latestCheckedIdRef.current === id) return;
    latestCheckedIdRef.current = id;
    checkLatestRiskJudge();
    checkLatestChatResponsePredict();
  }, [id, chatsInitiallyLoaded, isAIVisible, localGovId]);

  const getSettingServey = () => {
    const payload: IPayloadGetSettingServey = {
      onSuccess: (dataOrg) => {
        if (dataOrg) {
          let new_data_org = { ...dataOrg };
          if (!has(dataOrg, 'is_allow_servey')) {
            new_data_org['is_allow_servey'] = false;
          }
          setStandByAI(new_data_org.standby_ai);
          setLocalGovId(new_data_org.ai_gov_id);
          setSurveyStatus(new_data_org.is_allow_servey);
        }
        setLoading(false);
      },
      onError: () => {
        setLoading(false);
      },
    };
    dispatch(getSettingServeyAction(payload));
  };

  const getCreateTestIncident = () => {
    const payload: IPayloadGetCreateTestIncident = {
      values: {
        incident_id: id,
      },
      onSuccess: (data) => {
        if (data) {
          setCreateTestIncident(data);
        }
        setLoading(false);
      },
      onError: () => {
        setLoading(false);
      },
    };
    dispatch(getCreateTestIncidentAction(payload));
  };

  const loadingUpdateDetailIncident = (data, key) => {
    if (data?.happened_at) {
      data = { ...data, happened_at: moment(data.happened_at).format('YYYY/MM/DD') };
    }
    const payload: IPayloadActionUpdateDetailIncident = {
      data,
      onSuccess: () => {
        showSuccess(translate(`incidents.detail.update.${key.toLowerCase()}.success`));
        getActivityLog();
        setIsVisiableConfirm(false);
        if (codeStatusChange === EStatus.UNREAD) {
          return history.push('/admin/incidents');
        } else {
          getIncidentDetail();
        }
      },
      onError: () => {
        showError(translate(`error.common`));
        refFormDetail?.();
        setIsVisiableConfirm(false);
      },
    };
    dispatch(updateDetailIncidentAction(payload));
  };

  const postDeactiveUser = React.useCallback(
    async (id: string) => {
      const payload: IPayLoadDeactiveUser = {
        active_user_id: data?.active_user_id?._id,
        incident_id: id,
        onSuccess: () => {
          showSuccess(translate('incidents.detail.blockUser.success'));
          getIncidentDetail();
          getActivityLog();
          setIsVisiableConfirm(false);
        },
        onError: (errorCode: string) => {
          showError(translate(`error`));
          console.log('🚀 ~ errorCode', errorCode);
        },
      };

      return dispatch(postDeactiveUserAction(payload));
    },
    [data]
  );

  const prorityChange = (e) => {
    const prorityUpdate = {
      incident_id: id,
      priority: e._id ? e._id : null,
    };
    loadingUpdateDetailIncident(prorityUpdate, 'PRIORITY');
  };

  const handleVisibleShare = () => {
    setIsVisibleShare(true);
    handleCancelChat();
  };

  const onCancelShareIncident = () => {
    setIsVisibleShare(false);
    ref.current!?.resetFields();
  };

  const handleChangeTab = (activeKey: string) => {
    if (activeKey === 'Chat') {
      return handleVisibleChat();
    }
    setActiveKeyTab(activeKey);
  };

  /**
   * Function for Chat
   */

  const handleVisibleChat = () => {
    setIsVisibleChat(true);
  };

  const handleCancelChat = () => {
    setIsVisibleChat(false);
    removeUrlParameter('open_chat');
  };

  // const handleDisabledMoveChat = (value: boolean) => {
  //   setIsDiabledMoveChat(value);
  // };

  // const onStartDragChat = (event: any, uiData: any) => {
  //   const { clientWidth, clientHeight } = window?.document?.documentElement;
  //   const targetRect = draggleChatRef?.current?.getBoundingClientRect();

  //   const newBoundsChat: IBoundsChat = {
  //     left: -targetRect?.left + uiData?.x,
  //     right: clientWidth - (targetRect?.right - uiData?.x),
  //     top: -targetRect?.top + uiData?.y,
  //     bottom: clientHeight - (targetRect?.bottom - uiData?.y),
  //   };

  //   setBoundsChat(newBoundsChat);
  // };

  const renderIconChat = () => {
    let src: string = '';

    switch (statusChats || data?.response_status) {
      case EFilterResponseStatusIncidents.READ_ANSWERED:
        src = '/images/ic-read-anwered.png';
        break;
      case EFilterResponseStatusIncidents.READ_UNANSWERED:
        src = '/images/ic-read-unanwered.png';
        break;
      default:
        src = '/images/ic-unread.png';
        break;
    }

    return <img alt="" src={src} />;
  };

  const onClickChangeStatusChat = () => {
    if (data?.status?.code === EStatus.CLOSED) {
      setIsDisable(true);
    }
  };
  const renderTabChat = () => {
    return (
      <Space size={10} onClick={onClickChangeStatusChat}>
        {renderIconChat()}
        <Typography.Text>{`${translate('incidents.detail.chat')} (${
          chats.length
        })`}</Typography.Text>
      </Space>
    );
  };

  // Deactive user
  const handleShowDeactive = () => {
    handleCancelChat();
    setInfoModal({
      typeModal: 'deactive',
      titleModal: translate('incidents.detail.header.deactive.title'),
      contentText: translate('incidents.detail.header.deactive.content.text'),
      textConfirm: translate('incidents.detail.header.deactive.button.deactive'),
      isDeleted: true,
    });
    setIsVisiableConfirm(true);
  };

  // Closed Status
  const handleShowCloseStatus = (key: number, id: string, code: number) => {
    if (key === EStatus.CLOSED) {
      setIdChangeStatus(id);
      setCodeStatusChange(code);
      setInfoModal({
        typeModal: 'closed',
        titleModal: translate('incidents.detail.formDetail.Modal.closed.title'),
        contentText: translate('incidents.detail.formDetail.Modal.closed.text'),
        textConfirm: translate('incidents.detail.formDetail.Modal.closed.closed'),
        isDeleted: true,
      });
    } else if (key === EStatus.UNREAD) {
      setIdChangeStatus(id);
      setCodeStatusChange(code);
      setInfoModal({
        typeModal: 'change',
        titleModal: translate('modal.content.unread.title'),
        contentText: translate('modal.content.unread'),
        textConfirm: translate('common.ok'),
        isDeleted: true,
      });
    } else {
      setIdChangeStatus(id);
      setCodeStatusChange(code);
      setInfoModal({
        typeModal: 'change',
        titleModal: translate('incidents.detail.formDetail.Modal.change.title'),
        contentText: translate('incidents.detail.formDetail.Modal.change.conttext'),
        textConfirm: translate('incidents.detail.formDetail.Modal.change.changeStatus'),
        isDeleted: false,
      });
    }
    setIsVisiableConfirm(true);
  };

  const handleUpdate = () => {
    if (infoModal?.typeModal !== 'deactive') {
      const statusUpdate = {
        incident_id: id,
        status: idChangeStatus,
      };
      loadingUpdateDetailIncident(statusUpdate, 'STATUS');
    } else {
      if (data?.active_user_id?._id) {
        postDeactiveUser(id);
      }
    }
  };

  const handleCancel = () => {
    refFormDetail?.();
    setIsVisiableConfirm(false);
  };
  const renderFlag = () => {
    const color: string | undefined =
      optionsPriority &&
      data?.priority?.name !== 'NORMAL' &&
      optionsPriority.find((e) => e.name === data?.priority?.name)?.color;
    if (!color)
      return <FlagOutlined title={translate('incident.pdf.question.admin.flag')}> </FlagOutlined>;
    return <FlagFilled title={translate('incident.pdf.question.admin.flag')} style={{ color }} />;
  };
  return (
    <Spin spinning={loading} size="small">
      <div
        onDragStart={(e) => {
          e.preventDefault();
        }}
        draggable={false}
        className="detail-incidents"
      >
        <Header className="header-incidents">
          <div className="header-info">
            <div className="info">
              <Typography.Title className="info-title title-left">
                {translate('incidents.detail.header.infoTitleRight', { number: data?.sequence })}
              </Typography.Title>
              <Typography.Title
                className="info-title info-org-name "
                ellipsis={{ tooltip: true, rows: 1, expandable: false, symbol: '...' }}
              >
                {data?.org_id?.name}
              </Typography.Title>
              {!data?.is_survey_answered && surveyStatus && (
                <Tag color="#E1E1E1">
                  <span style={{ color: '#777777' }}>
                    {translate('incident.detail.title.is_survey_not_answer')}
                  </span>
                </Tag>
              )}

              {data?.is_survey_answered && (
                <Tag color="#34C7591A">
                  <span style={{ color: '#34C759' }}>
                    {translate('incident.detail.title.is_survey_answered')}
                    {moment(data?.incident_survey?.createdAt).format('YYYY/MM/DD HH:mm')}
                  </span>
                </Tag>
              )}
            </div>
            <div className="info">
              <Typography.Text className="info-text text-left _bottom">
                {translate('incidents.detail.header.viaPlatform', {
                  platform: translate(
                    `platform.type${
                      data?.active_user_id?.platform || data?.import_id
                        ? data?.active_user_id?.platform || 'WEB'
                        : ''
                    }`
                  ),
                })}
              </Typography.Text>
              <Typography.Text className="info-text text-left _bottom">
                {data && moment(data.createdAt).format('YYYY/MM/DD HH:mm')}
              </Typography.Text>
            </div>
          </div>
          <div className="header-box-center">
            {(data?.status?.code === EStatus.CLOSED ||
              (data?.active_user_id && !data?.active_user_id?.is_active) ||
              (data?.active_user_id && data?.active_user_id?.is_logged_out)) && (
              <>
                {data?.status?.code === EStatus.CLOSED && (
                  <Typography.Text className="text-close">
                    {translate(`incidents.detail.listDetail.header.text.closed`)}
                  </Typography.Text>
                )}
                {data?.active_user_id && !data?.active_user_id?.is_active && (
                  <Typography.Text className="text-close">
                    {translate(`incidents.detail.listDetail.header.text.deactived_user`)}
                  </Typography.Text>
                )}
                {data?.active_user_id && data?.active_user_id?.is_logged_out && (
                  <Typography.Text className="text-close">
                    {translate(`incidents.detail.listDetail.header.text.logout_user`)}
                  </Typography.Text>
                )}
                {/* <Typography.Text className="text-closed">
                  {data?.status?.code === EStatus.CLOSED &&
                    t(`incidents.detail.listDetail.header.text.closed`)}
                  {data?.active_user_id &&
                    !data?.active_user_id?.is_active &&
                    t(`incidents.detail.listDetail.header.text.deactived_user`)}
                  {data?.active_user_id &&
                    data?.active_user_id?.is_logged_out &&
                    t(`incidents.detail.listDetail.header.text.logout_user`)}
                </Typography.Text> */}
              </>
            )}
          </div>
          <div className="header-list">
            {createTestIncident && (
              <Tag color="#DEDEDE">
                <span style={{ color: '#343434', fontSize: 12 }}>
                  {translate('incident.detail.title.create_incident_test')}&nbsp;
                  {moment(createTestIncident?.createdAt).format('YYYY/MM/DD HH:mm')}
                </span>
              </Tag>
            )}
            {isAIVisible && (
              <div className="ai-actions">
                <button
                  type="button"
                  className="ai-btn"
                  onClick={handleRiskJudge}
                  disabled={loadingRiskJudge || riskJudgeSuccess}
                >
                  <RetweetOutlined className="ai-btn-icon" spin={loadingRiskJudge} />
                  <span>{!loadingRiskJudge ? `AI情報更新` : `AI情報更新中`}</span>
                </button>
                <button
                  type="button"
                  className="ai-btn"
                  onClick={() => setIsVisibleRiskJudgeModal(true)}
                  disabled={!riskJudgeSuccess}
                >
                  <span>リスク判定</span>
                  {riskJudgeSuccess && riskJudgeResult?.level ? (
                    <span className={`ai-pill ai-pill-${riskJudgeResult.level}`}>
                      {riskJudgeResult.level}
                    </span>
                  ) : (
                    <span className={`ai-pill ai-pill-disable`}>-</span>
                  )}
                </button>
                <button
                  type="button"
                  className="ai-btn"
                  onClick={() => setIsVisibleAISummaryModal(true)}
                  disabled={!riskJudgeSuccess}
                >
                  <span>AI要約</span>
                </button>
                <button type="button" className="ai-btn" onClick={handleChatResponsePredict}>
                  <span>AI返信案</span>
                </button>
              </div>
            )}
            {data?.active_user_id && data?.active_user_id?.is_active && currentRole !== 'RO' && (
              <Image
                preview={false}
                src="/images/ic-stop.png"
                title={translate('common.blockUser')}
                onClick={handleShowDeactive}
              />
            )}
            <Dropdown
              overlay={menuShare}
              trigger={['click']}
              overlayClassName="dropdown-menu-export"
            >
              <Image
                title={translate('common.export')}
                preview={false}
                src="/images/ic-download.png"
              />
            </Dropdown>
            {currentRole !== 'RO' && (
              <Image
                preview={false}
                src="/images/ic-share.png"
                title={translate('incidents.detail.share.title')}
                onClick={handleVisibleShare}
              />
            )}
            <div>
              <Dropdown
                disabled={currentRole === 'RO' ? true : false}
                overlay={menuFlag}
                trigger={['click']}
                overlayClassName="dropdown-menu-priority"
              >
                {renderFlag()}
              </Dropdown>
            </div>
          </div>
        </Header>
        <Content className="container">
          <Row className="row">
            <Col span={12} className="col-left">
              <Tabs activeKey={activeKeyTab} className="tabs" onChange={handleChangeTab}>
                <TabPane
                  className="tab-pane"
                  tab={
                    <Space size={12}>
                      {translate('incidents.detail.tabs.DETAIL')}
                      <Popover
                        placement="bottomRight"
                        content={
                          data?.active_user_id &&
                          !data?.active_user_id?.is_active &&
                          translate('incidents.detail.formDetail.Modal.Block.deactiveuser')
                        }
                        trigger="hover"
                        arrowPointAtCenter
                        className="popover-deactive"
                        color="#525673"
                      >
                        {data?.active_user_id && !data?.active_user_id?.is_active && (
                          <img alt="" src="/images/ic-disabled-user.png" />
                        )}
                      </Popover>
                      <Popover
                        placement="bottomRight"
                        content={
                          data?.active_user_id &&
                          data?.active_user_id?.is_logged_out &&
                          translate('incidents.detail.formDetail.Modal.Block.logoutUser')
                        }
                        trigger="hover"
                        arrowPointAtCenter
                        className="popover-deactive"
                        color="#525673"
                      >
                        {data?.active_user_id && data?.active_user_id?.is_logged_out && (
                          <img alt="" src="/images/people.png" width="16" height="16" />
                        )}
                      </Popover>
                    </Space>
                  }
                  key="1"
                >
                  <ListIncidentDetail
                    data={data}
                    getActivityLog={getActivityLog}
                    getIncidentDetail={getIncidentDetail}
                    handleCancelChat={handleCancelChat}
                    currentRole={currentRole}
                  />
                </TabPane>
                <TabPane
                  className="tab-pane"
                  tab={translate('incidents.detail.tabs.NOTES')}
                  key="2"
                >
                  <Notes data={data} currentRole={currentRole} />
                </TabPane>
                <TabPane
                  className="tab-pane"
                  tab={translate('incidents.detail.tabs.ACTIVITY_LOG')}
                  key="3"
                >
                  <ActivityLog
                    isLoading={isLoading}
                    listActiviLog={listActiviLog}
                    getActivityLog={getActivityLog}
                    incidenId={id}
                  />
                </TabPane>
                {!data?.admin_id && (
                  <TabPane tab={renderTabChat()} key="Chat">
                    <div>{translate('incidents.detail.chat')}</div>
                  </TabPane>
                )}
              </Tabs>
            </Col>
            <Col span={12} className="col-right">
              <FormIncidentDetail
                onRef={(ref) => (refFormDetail = ref)}
                data={data}
                id={id}
                handleShowCloseStatus={handleShowCloseStatus}
                getActivityLog={getActivityLog}
                getIncidentDetail={getIncidentDetail}
                currentRole={currentRole}
              />
            </Col>
          </Row>
        </Content>
      </div>

      {/* Modal Share */}
      <ShareIncidentDetail ref={ref} isVisible={isVisibleShare} onCancel={onCancelShareIncident} />

      {/* Modal Chat */}
      <Chat
        isDisable={isDisable}
        isVisible={isVisibleChat}
        onCancel={handleCancelChat}
        data={data}
        defaultVisibleChat={defaultVisibleChat}
        currentRole={currentRole}
      />

      {/* Modal リスク判定 */}
      <Modal
        title="リスク判定"
        visible={isVisibleRiskJudgeModal}
        onCancel={() => setIsVisibleRiskJudgeModal(false)}
        footer={[
          <Button
            key="apply"
            type="primary"
            onClick={() => {
              const matchedPriority = optionsPriority?.find(
                (e) => e.name === riskJudgeResult?.level
              );
              if (matchedPriority) {
                prorityChange(matchedPriority);
              }
              setIsVisibleRiskJudgeModal(false);
            }}
          >
            レベル判定を適応する
          </Button>,
          <Button key="cancel" onClick={() => setIsVisibleRiskJudgeModal(false)}>
            キャンセル
          </Button>,
        ]}
      >
        <div className="risk-judge-modal">
          <div className="risk-judge-section">
            <p className="risk-judge-label">判定結果</p>
            {riskJudgeResult?.level && (
              <span className={`ai-pill ai-pill-${riskJudgeResult.level} ai-pill-level`}>
                {riskJudgeResult.level}
              </span>
            )}
          </div>
          <div className="risk-judge-section">
            <div className="risk-judge-section-header">
              <p className="risk-judge-label">判定理由</p>
              <CopyOutlined
                className="ai-summary-copy-icon"
                onClick={() => handleCopy(riskJudgeResult?.reason ?? '')}
              />
            </div>
            <p className="risk-judge-text">{riskJudgeResult?.reason}</p>
          </div>
        </div>
      </Modal>

      {/* Modal AI要約 */}
      <Modal
        visible={isVisibleAISummaryModal}
        onCancel={() => setIsVisibleAISummaryModal(false)}
        footer={null}
        width={600}
        title={
          <div className="ai-summary-modal-title">
            <span>AIによる要約</span>
          </div>
        }
      >
        <div className="ai-summary-modal">
          {/* 基本情報 */}
          <div className="ai-summary-section">
            <div className="ai-summary-section-header">
              <span className="ai-summary-label">基本情報</span>
              <CopyOutlined
                className="ai-summary-copy-icon"
                onClick={() =>
                  handleCopy(
                    [
                      `チャット数：${chatCount?.total ?? 0}（相談者：${
                        chatCount?.user ?? 0
                      } | Adminユーザー：${chatCount?.admin ?? 0}）`,
                      `フラグ：${data?.priority?.name ?? ''} [AIのおすすめ：${
                        riskJudgeResult?.level ?? ''
                      }]`,
                      riskJudgeResult?.sub_level
                        ? `ラベル：admin: ${(data?.labels ?? [])
                            .map((l: any) => l?.name)
                            .join('、')} [AIのおすすめ：${riskJudgeResult.sub_level.join('、')}]`
                        : null,
                      `報告相談の種類：admin: ${data?.type?.name ?? ''} [AIのおすすめ：${
                        riskJudgeResult?.classification ?? ''
                      }]`,
                    ]
                      .filter(Boolean)
                      .join('\n')
                  )
                }
              />
            </div>
            <ul className="ai-summary-list">
              <li>
                <span>
                  {`チャット数：${chatCount?.total ?? 0}（相談者：${
                    chatCount?.user ?? 0
                  } | Adminユーザー：${chatCount?.admin ?? 0}）`}
                </span>
              </li>
              <li>
                <span>フラッグ：{data?.priority?.name}</span>
                {riskJudgeResult?.level && (
                  <span className="">{`[AIのおすすめ：${riskJudgeResult.level}]`}</span>
                )}
                {(riskJudgeResult?.level || data?.priority?.name) &&
                  (riskJudgeResult?.level !== data?.priority?.name ? (
                    <span className="ai-summary-mismatch-badge">AIと不一致</span>
                  ) : (
                    <span className="ai-summary-mismatch-badge ai-summary-mismatch-badge--match">
                      AIと一致
                    </span>
                  ))}
              </li>
              <li>
                <span>報告相談の種類：</span>
                {riskJudgeResult?.classification && (
                  <>
                    <span className="">{`${data?.type?.name ?? ''}`}</span>
                    <span className="">{`[AIのおすすめ：${riskJudgeResult.classification}]`}</span>
                  </>
                )}
              </li>
            </ul>
          </div>

          {/* 要約 */}
          <div className="ai-summary-section">
            <div className="ai-summary-section-header">
              <span className="ai-summary-label">要約</span>
              <CopyOutlined
                className="ai-summary-copy-icon"
                onClick={() => handleCopy(riskJudgeResult?.summary ?? '')}
              />
            </div>
            <p className="ai-summary-text">{riskJudgeResult?.summary}</p>
          </div>

          {/* 主訴 */}
          <div className="ai-summary-section">
            <div className="ai-summary-section-header">
              <span className="ai-summary-label">主訴</span>
              <CopyOutlined
                className="ai-summary-copy-icon"
                onClick={() => handleCopy((riskJudgeResult?.chief_complaint ?? []).join('\n'))}
              />
            </div>
            <ul className="ai-summary-list">
              {(riskJudgeResult?.chief_complaint ?? []).map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </Modal>

      {/* Modal AI返信案 */}
      <Modal
        title="AIによる返信案"
        visible={isVisibleChatResponseModal}
        onCancel={() => setIsVisibleChatResponseModal(false)}
        footer={null}
        width={600}
      >
        <Spin spinning={loadingChatResponse}>
          <div style={{ minHeight: loadingChatResponse ? 300 : undefined }} />
          {!loadingChatResponse && (
            <div className="ai-summary-modal">
              {/* 直近のチャット */}
              <div className="ai-summary-section">
                <div className="ai-summary-section-header">
                  <span className="ai-summary-label">
                    直近のチャット（最新{Math.min(3, chats.length)}件）
                  </span>
                </div>
                <div className="ai-chat-preview">
                  {[...chats]
                    .sort(
                      (a: any, b: any) =>
                        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
                    )
                    .slice(-3)
                    .map((item: any, idx: number) => (
                      <div
                        key={idx}
                        className={`ai-chat-bubble-wrap ${
                          item?.is_admin ? 'ai-chat-right' : 'ai-chat-left'
                        }`}
                      >
                        <div
                          className={`ai-chat-bubble ${
                            item?.is_admin ? 'ai-chat-bubble--admin' : ''
                          }`}
                        >
                          {item?.text}
                        </div>
                        <span className="ai-chat-time">
                          {moment(item?.createdAt).format('HH:mm')}
                        </span>
                      </div>
                    ))}
                </div>
              </div>

              {/* 返信案 */}
              <div className="ai-summary-section">
                <div className="ai-summary-section-header">
                  <span className="ai-summary-label">返信案</span>
                  <CopyOutlined
                    className="ai-summary-copy-icon"
                    onClick={() => handleCopy(chatResponseResult?.answer ?? '')}
                  />
                </div>
                <p className="ai-summary-text">{chatResponseResult?.answer}</p>
              </div>

              {/* 見立て */}
              <div className="ai-summary-section">
                <div className="ai-summary-section-header">
                  <span className="ai-summary-label">見立て</span>
                  <CopyOutlined
                    className="ai-summary-copy-icon"
                    onClick={() => handleCopy((chatResponseResult?.summary ?? []).join('\n'))}
                  />
                </div>
                <ul className="ai-summary-list">
                  {(chatResponseResult?.summary ?? []).map((item: string, idx: number) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>

              {/* 返信の理由 */}
              <div className="ai-summary-section">
                <div className="ai-summary-section-header">
                  <span className="ai-summary-label">返信の理由</span>
                  <CopyOutlined
                    className="ai-summary-copy-icon"
                    onClick={() => handleCopy(chatResponseResult?.reason ?? '')}
                  />
                </div>
                <p className="ai-summary-text">{chatResponseResult?.reason}</p>
              </div>
            </div>
          )}
        </Spin>
      </Modal>

      <ModalConfirm
        isDeleted={infoModal?.isDeleted}
        title={infoModal?.titleModal}
        visible={isVisiableConfirm}
        handleOk={handleUpdate}
        handleCancel={handleCancel}
        contentText={infoModal?.contentText}
        textConfirmBtn={infoModal?.textConfirm}
      />
    </Spin>
  );
};

const DetailIncidents = () => {
  return <DetailIncidentsContent />;
};

export default React.memo(DetailIncidents);
